<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0060_redirect</div>
        <app-header no_menu="true">esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot style="width:100%" :title="messsage" >
          </title-and-slot>
          <div class="row" style="margin-bottom:10px;">
          </div>
          </div>
          </div>
</template>

<script>

import mixinPageCommon from '@/mixins/mixin_page_common';

export default {
  mixins: [mixinPageCommon],
  components: {},
  data() {
    return {
    };
  },
  computed: {
    messsage(){
      return this.$route.params.message ||"Loading..."
    },
    waitTime(){
      return this.$route.params.wait || 10;
    },
    url(){
      return this.$route.params.url || "/";
    }
  },
  methods: {},
  mounted() {

    setTimeout(() => {
      return this.$router.push(this.url);
    }, this.waitTime);


  },
  beforeDestroy() {},
  beforeMount() {},
};
</script>
<style >
.dropdown_yellow_import {
  margin-left: 0 !important;
  padding: 8px 10px !important;
  width: 300px !important;
  font-size: 14px !important;
}
</style>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0060_redirect.vue?20e5e1b0